import React from 'react';
import { Bars } from 'react-loader-spinner';

function Loader() {
  return (
    <div>
      <Bars height={25} color='#3b82f6' margin='0 auto' />
      <h1 className=' text-sm text-gray-400 mt-2'>Please wait...</h1>
    </div>
  );
}

export function ShowEmptyView(props) {
  return <h1 className=' text-sm text-gray-400'>{props.text}</h1>;
}

export default Loader;
